export const ru = {
    'logo': 'Хурал',
    'last-khurals': 'Прошедшие хуралы',
};